const CountType = Object.freeze({
  MENTIONS: 'MENTIONS',
  AUTHORS: 'AUTHORS',
  POSTS: 'POSTS'
})
export default CountType
export type CountTypeStrings = typeof CountType[keyof typeof CountType]
// RESERVE BELOW
